import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { PaymentTermsService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class GetPaymentTermsResolver implements Resolve<any> {

  constructor(private paymentTermsService: PaymentTermsService) { }

  resolve() {
    return this.paymentTermsService.load();
  }
}
